// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --pt-brand: var(--fc-brand, #5ea1d8);
  --pt-bg: #f4f6f9;
  --pt-surface: #ffffff;
  --pt-text: #111827;
  --pt-muted: #6b7280;
  --pt-border: #e5e7eb;
  --pt-track: #e5e7eb;
  --pt-warn-bg: #fff7ed;
  --pt-warn-border: #fdba74;
  --pt-warn-text: #9a3412;
  --pt-header-offset: 56px;
  display: block;
}

:host-context(.theme-dark-layout),
:host-context(body.theme-dark) {
  --pt-bg: #0a0c10;
  --pt-surface: #151922;
  --pt-text: #f3f4f6;
  --pt-muted: #9ca3af;
  --pt-border: #262c38;
  --pt-track: #262c38;
  --pt-warn-bg: rgba(251, 146, 60, 0.12);
  --pt-warn-border: rgba(251, 146, 60, 0.45);
  --pt-warn-text: #fdba74;
}

.perform-page {
  background: var(--pt-bg);
  color: var(--pt-text);
  min-height: calc(100vh - var(--pt-header-offset));
  min-height: calc(100dvh - var(--pt-header-offset));
  display: flex;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
}

.perform-shell {
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: column;
  background: var(--pt-surface);
  border: 1px solid var(--pt-border);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

/* Header */
.perform-header {
  position: sticky;
  top: var(--pt-header-offset);
  z-index: 5;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  -moz-column-gap: 12px;
       column-gap: 12px;
  row-gap: 12px;
  padding: 14px 16px;
  background: var(--pt-surface);
  border-bottom: 1px solid var(--pt-border);
  border-radius: 20px 20px 0 0;
}

/* mat-icon defaults to a 24px box with inherited line-height, which drifts off the text baseline inside flex buttons */
.icon-btn {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid var(--pt-border);
  border-radius: 12px;
  background: transparent;
  color: var(--pt-text);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;
}
.icon-btn mat-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  font-size: 22px;
  line-height: 22px;
  overflow: visible;
}
.icon-btn:hover {
  background: var(--pt-bg);
}
.icon-btn:focus-visible {
  outline: 2px solid var(--pt-brand);
  outline-offset: 2px;
}

/* Title + version, centred against the 44px icon buttons */
.progress-wrap {
  flex: 1 1 0;
  min-width: 0;
  min-height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.progress-meta {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  font-size: 13px;
}

/* Sized to sit beside the 44px header icon buttons */
.progress-title {
  min-width: 0;
  font-size: 1.125rem;
  line-height: 1.3;
  font-weight: 700;
  color: var(--pt-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.progress-sub {
  display: flex;
  align-items: center;
  gap: 8px;
}

.version-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid var(--pt-border);
  border-radius: 999px;
  background: transparent;
  color: var(--pt-muted);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
}
.version-chip mat-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  overflow: visible;
}
.version-chip:hover {
  color: var(--pt-brand);
  border-color: var(--pt-brand);
}
.version-chip:focus-visible {
  outline: 2px solid var(--pt-brand);
  outline-offset: 2px;
}

.progress-count {
  flex: 0 0 auto;
  color: var(--pt-muted);
  font-variant-numeric: tabular-nums;
}

/* Full-width row under the header controls */
.progress-bar {
  flex: 1 0 100%;
  height: 8px;
  background: var(--pt-track);
  border-radius: 999px;
  overflow: hidden;
}
.progress-bar span {
  display: block;
  height: 100%;
  background: var(--pt-brand);
  border-radius: inherit;
  transition: width 0.3s ease;
}

/* Body */
.perform-body {
  flex: 1;
  padding: 24px;
}
.perform-body h1 {
  font-size: 1.75rem;
  line-height: 1.25;
  font-weight: 700;
  margin: 4px 0 12px;
  color: var(--pt-text);
  word-break: break-word;
}

.center {
  text-align: center;
}

.eyebrow {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--pt-brand);
}

.lead {
  font-size: 1.05rem;
  line-height: 1.5;
  color: var(--pt-muted);
  margin: 0 0 20px;
}

.media {
  margin: -8px -8px 20px;
  border-radius: 14px;
  overflow: hidden;
  background: #000;
  aspect-ratio: 16/9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.media img,
.media video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.rich {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--pt-text);
  word-break: break-word;
}
.rich ::ng-deep p {
  margin: 0 0 12px;
}
.rich ::ng-deep img,
.rich ::ng-deep video,
.rich ::ng-deep iframe {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}
.rich ::ng-deep ul,
.rich ::ng-deep ol {
  padding-left: 22px;
  margin: 0 0 12px;
}
.rich ::ng-deep a {
  color: var(--pt-brand);
}
.rich ::ng-deep * {
  color: inherit !important;
  background-color: transparent !important;
}

.safety {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  margin: 0 0 20px;
  border: 1px solid var(--pt-warn-border);
  background: var(--pt-warn-bg);
  color: var(--pt-warn-text);
  border-radius: 12px;
}
.safety mat-icon {
  flex: 0 0 auto;
}
.safety strong {
  display: block;
  margin-bottom: 4px;
}
.safety .rich {
  color: var(--pt-warn-text);
  font-size: 0.95rem;
}

.resume-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  border: 1px dashed var(--pt-brand);
  border-radius: 12px;
  background: transparent;
  color: var(--pt-brand);
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}
.resume-btn mat-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  overflow: visible;
}
.resume-btn:hover {
  background: color-mix(in srgb, var(--pt-brand) 8%, transparent);
}

/* Save, error and issue messages under the step */
.notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  margin: 16px 0 0;
  border-radius: 12px;
  border: 1px solid var(--pt-border);
  background: var(--pt-bg);
  color: var(--pt-text);
  font-size: 0.95rem;
  line-height: 1.45;
}
.notice mat-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  overflow: visible;
  margin-top: 1px;
}
.notice--info {
  border-color: color-mix(in srgb, var(--pt-brand) 40%, transparent);
  background: color-mix(in srgb, var(--pt-brand) 8%, var(--pt-surface));
}
.notice--info mat-icon {
  color: var(--pt-brand);
}
.notice--error {
  border-color: rgba(220, 38, 38, 0.35);
  background: rgba(220, 38, 38, 0.06);
  color: #b42318;
}
.notice--error mat-icon {
  color: #dc2626;
}
.notice--warn {
  border-color: var(--pt-warn-border);
  background: var(--pt-warn-bg);
  color: var(--pt-warn-text);
}
.notice ul {
  margin: 4px 0 0;
  padding-left: 18px;
}
.notice li + li {
  margin-top: 2px;
}

.cover-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* Done */
.done-badge {
  width: 72px;
  height: 72px;
  margin: 8px auto 16px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--pt-brand) 15%, transparent);
  color: var(--pt-brand);
}
.done-badge mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
}
.done-badge--ok {
  background: rgba(34, 197, 94, 0.15);
  color: #16a34a;
}

.checklist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.check-row {
  position: relative;
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  min-height: 56px;
  box-sizing: border-box;
  border: 1px solid var(--pt-border);
  border-radius: 12px;
  background: var(--pt-surface);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.check-row input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.check-row:focus-within {
  outline: 2px solid var(--pt-brand);
  outline-offset: 2px;
}
.check-row--on {
  border-color: var(--pt-brand);
  background: color-mix(in srgb, var(--pt-brand) 8%, var(--pt-surface));
}

.check-box {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border: 2px solid var(--pt-border);
  border-radius: 6px;
  display: grid;
  place-items: center;
  color: transparent;
}
.check-box mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.check-row--on .check-box {
  background: var(--pt-brand);
  border-color: var(--pt-brand);
  color: #fff;
}

.check-label {
  font-size: 1rem;
  line-height: 1.4;
}

/* Action bar */
.perform-actions {
  position: sticky;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: stretch;
  gap: 12px;
  padding: 14px 16px;
  padding-bottom: calc(14px + env(safe-area-inset-bottom, 0px));
  background: var(--pt-surface);
  border-top: 1px solid var(--pt-border);
  border-radius: 0 0 20px 20px;
}

.primary-btn,
.secondary-btn {
  box-sizing: border-box;
  min-height: 52px;
  height: 52px;
  padding: 0 20px;
  border-radius: 14px;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: filter 0.15s ease, background 0.15s ease, opacity 0.15s ease;
}
.primary-btn mat-icon,
.secondary-btn mat-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  overflow: visible;
}
.primary-btn:focus-visible,
.secondary-btn:focus-visible {
  outline: 2px solid var(--pt-brand);
  outline-offset: 2px;
}

.btn-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.primary-btn {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  background: var(--pt-brand);
  color: #fff;
}
.primary-btn:hover:not(:disabled) {
  filter: brightness(0.95);
}
.primary-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.secondary-btn {
  flex: 0 0 auto;
  border: 1px solid var(--pt-border);
  background: transparent;
  color: var(--pt-text);
}
.secondary-btn:hover {
  background: var(--pt-bg);
}

/* Icon-only "more" button beside the primary action */
.more-btn {
  width: 52px;
  padding: 0;
}
.more-btn mat-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  font-size: 22px;
  line-height: 22px;
  overflow: visible;
}

/* Loading / error */
.perform-state {
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: var(--pt-muted);
  text-align: center;
}
.perform-state .state-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
}

.state-actions {
  display: flex;
  gap: 12px;
}

/* Mobile: full-bleed, app-like */
@media (max-width: 768px) {
  .perform-page {
    padding: 0;
  }
  .perform-shell {
    max-width: none;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .perform-header {
    border-radius: 0;
    padding: 10px 12px;
    -moz-column-gap: 10px;
         column-gap: 10px;
    row-gap: 10px;
  }
  .progress-title {
    font-size: 1rem;
  }
  .perform-body {
    padding: 16px;
  }
  .perform-body h1 {
    font-size: 1.45rem;
  }
  .media {
    margin: -16px -16px 16px;
    border-radius: 0;
  }
  .perform-actions {
    /* Above the Google Translate banner the shell pins to the bottom on mobile (z-index 1001) */
    z-index: 1002;
    border-radius: 0;
    padding: 12px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  }
  .secondary-btn {
    padding: 0 14px;
  }
}
/* Icon-only secondary buttons leave the primary action enough room on phones */
@media (max-width: 520px) {
  .hide-xs {
    display: none;
  }
  .secondary-btn--icon {
    width: 52px;
    padding: 0;
  }
}
:host-context(.theme-dark-layout) .notice--error,
:host-context(body.theme-dark) .notice--error {
  color: #fda29b;
  background: rgba(220, 38, 38, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/perform-task/perform-task.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,cAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sCAAA;EACA,0CAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,qBAAA;EACA,iDAAA;EACA,kDAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kCAAA;EACA,mBAAA;EACA,8CAAA;AACF;;AAEA,WAAA;AACA;EACE,gBAAA;EACA,4BAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;OAAA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,yCAAA;EACA,4BAAA;AACF;;AAEA,uHAAA;AAaA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kCAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;AAXF;AAaE;EA1BA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAuBmB;EAtBnB,YAsBmB;EArBnB,eAqBmB;EApBnB,iBAoBmB;EAnBnB,iBAAA;AAgBF;AAME;EACE,wBAAA;AAJJ;AAOE;EACE,kCAAA;EACA,mBAAA;AALJ;;AASA,2DAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AANF;;AASA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;AANF;;AASA,qDAAA;AACA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANF;;AASA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kCAAA;EACA,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;AANF;AAQE;EA7FA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WA0FmB;EAzFnB,YAyFmB;EAxFnB,eAwFmB;EAvFnB,iBAuFmB;EAtFnB,iBAAA;AAwFF;AACE;EACE,sBAAA;EACA,6BAAA;AACJ;AAEE;EACE,kCAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,cAAA;EACA,sBAAA;EACA,kCAAA;AADF;;AAIA,6CAAA;AACA;EACE,cAAA;EACA,WAAA;EACA,2BAAA;EACA,oBAAA;EACA,gBAAA;AADF;AAGE;EACE,cAAA;EACA,YAAA;EACA,2BAAA;EACA,sBAAA;EACA,2BAAA;AADJ;;AAKA,SAAA;AACA;EACE,OAAA;EACA,aAAA;AAFF;AAIE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AAFJ;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;AAKE;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AAJF;AAOI;EACE,gBAAA;AALN;AAOI;;;EAGE,eAAA;EACA,YAAA;EACA,mBAAA;AALN;AAOI;;EAEE,kBAAA;EACA,gBAAA;AALN;AAOI;EACE,sBAAA;AALN;AAOI;EACE,yBAAA;EACA,wCAAA;AALN;;AAUA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,6BAAA;EACA,0BAAA;EACA,mBAAA;AAPF;AASE;EACE,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,kBAAA;AARJ;AAWE;EACE,0BAAA;EACA,kBAAA;AATJ;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAVF;AAYE;EAnQA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAgQmB;EA/PnB,YA+PmB;EA9PnB,eA8PmB;EA7PnB,iBA6PmB;EA5PnB,iBAAA;AA0PF;AAKE;EACE,+DAAA;AAHJ;;AAOA,kDAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AAJF;AAME;EA1RA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAuRmB;EAtRnB,YAsRmB;EArRnB,eAqRmB;EApRnB,iBAoRmB;EAnRnB,iBAAA;EAoRE,eAAA;AAIJ;AADE;EACE,kEAAA;EACA,qEAAA;AAGJ;AADI;EACE,sBAAA;AAGN;AACE;EACE,qCAAA;EACA,mCAAA;EACA,cAAA;AACJ;AACI;EACE,cAAA;AACN;AAGE;EACE,mCAAA;EACA,6BAAA;EACA,0BAAA;AADJ;AAIE;EACE,eAAA;EACA,kBAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;;AAOA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAJF;;AAOA,SAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gEAAA;EACA,sBAAA;AAJF;AAME;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAJJ;AAOE;EACE,mCAAA;EACA,cAAA;AALJ;;AASA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AANF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,0DAAA;AANF;AAQE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AANJ;AASE;EACE,kCAAA;EACA,mBAAA;AAPJ;AAUE;EACE,6BAAA;EACA,qEAAA;AARJ;;AAYA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AATF;AAWE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AATJ;AAYE;EACE,2BAAA;EACA,6BAAA;EACA,WAAA;AAVJ;;AAcA;EACE,eAAA;EACA,gBAAA;AAXF;;AAcA,eAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,6DAAA;EACA,6BAAA;EACA,sCAAA;EACA,4BAAA;AAXF;;AAcA;;EAEE,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,wEAAA;AAXF;AAaE;;EAncA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAgcmB;EA/bnB,YA+bmB;EA9bnB,eA8bmB;EA7bnB,iBA6bmB;EA5bnB,iBAAA;AA0bF;AAKE;;EACE,kCAAA;EACA,mBAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,cAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAHF;AAKE;EACE,wBAAA;AAHJ;AAME;EACE,YAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,cAAA;EACA,kCAAA;EACA,uBAAA;EACA,qBAAA;AALF;AAOE;EACE,wBAAA;AALJ;;AASA,sDAAA;AACA;EACE,WAAA;EACA,UAAA;AANF;AAQE;EAnfA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAgfmB;EA/enB,YA+emB;EA9enB,eA8emB;EA7enB,iBA6emB;EA5enB,iBAAA;AA8eF;;AAEA,oBAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,aAAA;EACA,SAAA;AAAF;;AAGA,iCAAA;AACA;EACE;IACE,UAAA;EAAF;EAGA;IACE,eAAA;IACA,SAAA;IACA,gBAAA;IACA,gBAAA;EADF;EAIA;IACE,gBAAA;IACA,kBAAA;IACA,qBAAA;SAAA,gBAAA;IACA,aAAA;EAFF;EAKA;IACE,eAAA;EAHF;EAMA;IACE,aAAA;EAJF;EAME;IACE,kBAAA;EAJJ;EAQA;IACE,wBAAA;IACA,gBAAA;EANF;EASA;IACE,4FAAA;IACA,aAAA;IACA,gBAAA;IACA,aAAA;IACA,6DAAA;EAPF;EAUA;IACE,eAAA;EARF;AACF;AAWA,+EAAA;AACA;EACE;IACE,aAAA;EATF;EAYA;IACE,WAAA;IACA,UAAA;EAVF;AACF;AAeE;;EACE,cAAA;EACA,mCAAA;AAZJ","sourcesContent":[":host {\n  --pt-brand: var(--fc-brand, #5ea1d8);\n  --pt-bg: #f4f6f9;\n  --pt-surface: #ffffff;\n  --pt-text: #111827;\n  --pt-muted: #6b7280;\n  --pt-border: #e5e7eb;\n  --pt-track: #e5e7eb;\n  --pt-warn-bg: #fff7ed;\n  --pt-warn-border: #fdba74;\n  --pt-warn-text: #9a3412;\n  --pt-header-offset: 56px;\n  display: block;\n}\n\n:host-context(.theme-dark-layout),\n:host-context(body.theme-dark) {\n  --pt-bg: #0a0c10;\n  --pt-surface: #151922;\n  --pt-text: #f3f4f6;\n  --pt-muted: #9ca3af;\n  --pt-border: #262c38;\n  --pt-track: #262c38;\n  --pt-warn-bg: rgba(251, 146, 60, 0.12);\n  --pt-warn-border: rgba(251, 146, 60, 0.45);\n  --pt-warn-text: #fdba74;\n}\n\n.perform-page {\n  background: var(--pt-bg);\n  color: var(--pt-text);\n  min-height: calc(100vh - var(--pt-header-offset));\n  min-height: calc(100dvh - var(--pt-header-offset));\n  display: flex;\n  justify-content: center;\n  padding: 24px 16px;\n  box-sizing: border-box;\n}\n\n.perform-shell {\n  width: 100%;\n  max-width: 760px;\n  display: flex;\n  flex-direction: column;\n  background: var(--pt-surface);\n  border: 1px solid var(--pt-border);\n  border-radius: 20px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n/* Header */\n.perform-header {\n  position: sticky;\n  top: var(--pt-header-offset);\n  z-index: 5;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 12px;\n  row-gap: 12px;\n  padding: 14px 16px;\n  background: var(--pt-surface);\n  border-bottom: 1px solid var(--pt-border);\n  border-radius: 20px 20px 0 0;\n}\n\n/* mat-icon defaults to a 24px box with inherited line-height, which drifts off the text baseline inside flex buttons */\n@mixin pt-icon($size) {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: $size;\n  height: $size;\n  font-size: $size;\n  line-height: $size;\n  overflow: visible;\n}\n\n.icon-btn {\n  flex: 0 0 auto;\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  border: 1px solid var(--pt-border);\n  border-radius: 12px;\n  background: transparent;\n  color: var(--pt-text);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  mat-icon {\n    @include pt-icon(22px);\n  }\n\n  &:hover {\n    background: var(--pt-bg);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--pt-brand);\n    outline-offset: 2px;\n  }\n}\n\n/* Title + version, centred against the 44px icon buttons */\n.progress-wrap {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 44px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n}\n\n.progress-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n  font-size: 13px;\n}\n\n/* Sized to sit beside the 44px header icon buttons */\n.progress-title {\n  min-width: 0;\n  font-size: 1.125rem;\n  line-height: 1.3;\n  font-weight: 700;\n  color: var(--pt-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.progress-sub {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.version-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid var(--pt-border);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--pt-muted);\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  cursor: pointer;\n  transition: color 0.15s ease, border-color 0.15s ease;\n\n  mat-icon {\n    @include pt-icon(14px);\n  }\n\n  &:hover {\n    color: var(--pt-brand);\n    border-color: var(--pt-brand);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--pt-brand);\n    outline-offset: 2px;\n  }\n}\n\n.progress-count {\n  flex: 0 0 auto;\n  color: var(--pt-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Full-width row under the header controls */\n.progress-bar {\n  flex: 1 0 100%;\n  height: 8px;\n  background: var(--pt-track);\n  border-radius: 999px;\n  overflow: hidden;\n\n  span {\n    display: block;\n    height: 100%;\n    background: var(--pt-brand);\n    border-radius: inherit;\n    transition: width 0.3s ease;\n  }\n}\n\n/* Body */\n.perform-body {\n  flex: 1;\n  padding: 24px;\n\n  h1 {\n    font-size: 1.75rem;\n    line-height: 1.25;\n    font-weight: 700;\n    margin: 4px 0 12px;\n    color: var(--pt-text);\n    word-break: break-word;\n  }\n}\n\n.center {\n  text-align: center;\n}\n\n.eyebrow {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--pt-brand);\n}\n\n.lead {\n  font-size: 1.05rem;\n  line-height: 1.5;\n  color: var(--pt-muted);\n  margin: 0 0 20px;\n}\n\n.media {\n  margin: -8px -8px 20px;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #000;\n  aspect-ratio: 16 / 9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img,\n  video {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    display: block;\n  }\n}\n\n.rich {\n  font-size: 1.05rem;\n  line-height: 1.6;\n  color: var(--pt-text);\n  word-break: break-word;\n\n  ::ng-deep {\n    p {\n      margin: 0 0 12px;\n    }\n    img,\n    video,\n    iframe {\n      max-width: 100%;\n      height: auto;\n      border-radius: 10px;\n    }\n    ul,\n    ol {\n      padding-left: 22px;\n      margin: 0 0 12px;\n    }\n    a {\n      color: var(--pt-brand);\n    }\n    * {\n      color: inherit !important;\n      background-color: transparent !important;\n    }\n  }\n}\n\n.safety {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px 16px;\n  margin: 0 0 20px;\n  border: 1px solid var(--pt-warn-border);\n  background: var(--pt-warn-bg);\n  color: var(--pt-warn-text);\n  border-radius: 12px;\n\n  mat-icon {\n    flex: 0 0 auto;\n  }\n\n  strong {\n    display: block;\n    margin-bottom: 4px;\n  }\n\n  .rich {\n    color: var(--pt-warn-text);\n    font-size: 0.95rem;\n  }\n}\n\n.resume-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 16px;\n  border: 1px dashed var(--pt-brand);\n  border-radius: 12px;\n  background: transparent;\n  color: var(--pt-brand);\n  font-family: inherit;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n\n  mat-icon {\n    @include pt-icon(20px);\n  }\n\n  &:hover {\n    background: color-mix(in srgb, var(--pt-brand) 8%, transparent);\n  }\n}\n\n/* Save, error and issue messages under the step */\n.notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  margin: 16px 0 0;\n  border-radius: 12px;\n  border: 1px solid var(--pt-border);\n  background: var(--pt-bg);\n  color: var(--pt-text);\n  font-size: 0.95rem;\n  line-height: 1.45;\n\n  mat-icon {\n    @include pt-icon(20px);\n    margin-top: 1px;\n  }\n\n  &--info {\n    border-color: color-mix(in srgb, var(--pt-brand) 40%, transparent);\n    background: color-mix(in srgb, var(--pt-brand) 8%, var(--pt-surface));\n\n    mat-icon {\n      color: var(--pt-brand);\n    }\n  }\n\n  &--error {\n    border-color: rgba(220, 38, 38, 0.35);\n    background: rgba(220, 38, 38, 0.06);\n    color: #b42318;\n\n    mat-icon {\n      color: #dc2626;\n    }\n  }\n\n  &--warn {\n    border-color: var(--pt-warn-border);\n    background: var(--pt-warn-bg);\n    color: var(--pt-warn-text);\n  }\n\n  ul {\n    margin: 4px 0 0;\n    padding-left: 18px;\n  }\n\n  li + li {\n    margin-top: 2px;\n  }\n}\n\n.cover-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n/* Done */\n.done-badge {\n  width: 72px;\n  height: 72px;\n  margin: 8px auto 16px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: color-mix(in srgb, var(--pt-brand) 15%, transparent);\n  color: var(--pt-brand);\n\n  mat-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n  }\n\n  &--ok {\n    background: rgba(34, 197, 94, 0.15);\n    color: #16a34a;\n  }\n}\n\n.checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.check-row {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 14px 16px;\n  min-height: 56px;\n  box-sizing: border-box;\n  border: 1px solid var(--pt-border);\n  border-radius: 12px;\n  background: var(--pt-surface);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  &:focus-within {\n    outline: 2px solid var(--pt-brand);\n    outline-offset: 2px;\n  }\n\n  &--on {\n    border-color: var(--pt-brand);\n    background: color-mix(in srgb, var(--pt-brand) 8%, var(--pt-surface));\n  }\n}\n\n.check-box {\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  border: 2px solid var(--pt-border);\n  border-radius: 6px;\n  display: grid;\n  place-items: center;\n  color: transparent;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  .check-row--on & {\n    background: var(--pt-brand);\n    border-color: var(--pt-brand);\n    color: #fff;\n  }\n}\n\n.check-label {\n  font-size: 1rem;\n  line-height: 1.4;\n}\n\n/* Action bar */\n.perform-actions {\n  position: sticky;\n  bottom: 0;\n  z-index: 5;\n  display: flex;\n  align-items: stretch;\n  gap: 12px;\n  padding: 14px 16px;\n  padding-bottom: calc(14px + env(safe-area-inset-bottom, 0px));\n  background: var(--pt-surface);\n  border-top: 1px solid var(--pt-border);\n  border-radius: 0 0 20px 20px;\n}\n\n.primary-btn,\n.secondary-btn {\n  box-sizing: border-box;\n  min-height: 52px;\n  height: 52px;\n  padding: 0 20px;\n  border-radius: 14px;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: filter 0.15s ease, background 0.15s ease, opacity 0.15s ease;\n\n  mat-icon {\n    @include pt-icon(20px);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--pt-brand);\n    outline-offset: 2px;\n  }\n}\n\n.btn-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.primary-btn {\n  flex: 1 1 auto;\n  min-width: 0;\n  border: 0;\n  background: var(--pt-brand);\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    filter: brightness(0.95);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.secondary-btn {\n  flex: 0 0 auto;\n  border: 1px solid var(--pt-border);\n  background: transparent;\n  color: var(--pt-text);\n\n  &:hover {\n    background: var(--pt-bg);\n  }\n}\n\n/* Icon-only \"more\" button beside the primary action */\n.more-btn {\n  width: 52px;\n  padding: 0;\n\n  mat-icon {\n    @include pt-icon(22px);\n  }\n}\n\n/* Loading / error */\n.perform-state {\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: var(--pt-muted);\n  text-align: center;\n\n  .state-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n  }\n}\n\n.state-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Mobile: full-bleed, app-like */\n@media (max-width: 768px) {\n  .perform-page {\n    padding: 0;\n  }\n\n  .perform-shell {\n    max-width: none;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .perform-header {\n    border-radius: 0;\n    padding: 10px 12px;\n    column-gap: 10px;\n    row-gap: 10px;\n  }\n\n  .progress-title {\n    font-size: 1rem;\n  }\n\n  .perform-body {\n    padding: 16px;\n\n    h1 {\n      font-size: 1.45rem;\n    }\n  }\n\n  .media {\n    margin: -16px -16px 16px;\n    border-radius: 0;\n  }\n\n  .perform-actions {\n    /* Above the Google Translate banner the shell pins to the bottom on mobile (z-index 1001) */\n    z-index: 1002;\n    border-radius: 0;\n    padding: 12px;\n    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .secondary-btn {\n    padding: 0 14px;\n  }\n}\n\n/* Icon-only secondary buttons leave the primary action enough room on phones */\n@media (max-width: 520px) {\n  .hide-xs {\n    display: none;\n  }\n\n  .secondary-btn--icon {\n    width: 52px;\n    padding: 0;\n  }\n}\n\n:host-context(.theme-dark-layout),\n:host-context(body.theme-dark) {\n  .notice--error {\n    color: #fda29b;\n    background: rgba(220, 38, 38, 0.12);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
